<template>
  <div class="box">
    <el-dialog
      :visible.sync="outerVisible"
      :close-on-click-modal="false"
      width="45%"
      center
      @close="firstLoginClose"
    >
      <div slot="title" class="title">修改登录密码</div>
      <div
        style="
          padding: 20px 30px;
          background-color: #f0f5ff;
          border-radius: 2px;
          margin: 0 20px;
        "
      >
        <el-form
          ref="ruleFormPass"
          :model="ruleFormPass"
          status-icon
          :rules="rulesPass"
          :hide-required-asterisk="true"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="旧密码" prop="oldPass">
            <el-input
              v-model="ruleFormPass.oldPass"
              size="mini"
              type="password"
              autocomplete="off"
              placeholder="请输入旧密码"
            />
          </el-form-item>
          <el-form-item label="新密码" prop="pass">
            <el-input
              v-model="ruleFormPass.pass"
              size="mini"
              type="password"
              autocomplete="off"
              placeholder="请输入新密码"
            />
          </el-form-item>
          <el-form-item label="确认密码" prop="checkPass">
            <el-input
              v-model="ruleFormPass.checkPass"
              size="mini"
              type="password"
              autocomplete="off"
              placeholder="请再次输入新密码"
            />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          size="mini"
          @click="submitForm('ruleFormPass')"
          >确 定</el-button
        >
        <el-button size="mini" @click="firstLoginClose">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { updatePass } from "@/api/user";
export default {
  name: "UpdataPass",
  props: {
    outerVisible: {
      type: Boolean,
    },
  },
  data() {
    var validateOldPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入旧密码"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleFormPass.checkPass !== "") {
          this.$refs.ruleFormPass.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleFormPass.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      ruleFormPass: {
        oldPass: "",
        pass: "",
        checkPass: "",
      },
      rulesPass: {
        oldPass: [{ validator: validateOldPass, trigger: "blur" }],
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
      },
      addActivevis: false,
    };
  },
  watch: {
    outerVisible(newVal) {
      this.addActivevis = newVal;
    },
  },
  methods: {
    firstLoginClose() {
      this.addActivevis = false;
      this.$emit("dialogHide");
    },
    // 修改密码
    submitForm(formName) {
      console.log(formName);

      this.$refs[formName].validate((valid) => {
        console.log(valid);
        if (valid) {
          const params = {
            old_pwd: this.ruleFormPass.oldPass,
            new_pwd: this.ruleFormPass.checkPass,
          };
          updatePass(params)
            .then((res) => {
              if (res && res.code === 0) {
                //更新缓存中的账号密码
                sessionStorage.setItem(
                  "iwrs_userForm",
                  JSON.stringify({
                    phone: JSON.parse(sessionStorage.getItem("iwrs_userForm"))
                      .phone,
                    password: params.new_pwd,
                  })
                );
                this.outerVisible = false;
                this.$message({
                  message: res.msg,
                  type: "success",
                });
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((res) => {
              console.log(res);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.box {
  padding: 10px 0;
  .el-dialog__body {
    padding: 0px !important;
  }
  .tab-phone {
    width: 70%;
    padding-top: 30px;
    margin: 0 auto;
    .btnPass {
      padding: 6px;
      position: absolute;
      right: 2%;
      top: 0%;
    }
  }
}
.title {
  padding: 18px 0;
  background-color: #d6e4ff;
  color: #595959;
  font-weight: 500;
  font-size: 16px;
}
</style>
